<template>
	<div class="kpi-row">
		<div v-for="k in kpis" :key="k.label" class="kpi-card">
			<div class="kpi-head">
				<span class="kpi-label">{{ k.label }}</span>
				<span class="kpi-icon" :title="k.hint"><i class="fas" :class="'fa-' + k.icon"></i></span>
			</div>
			<div class="kpi-value-row">
				<span class="kpi-value">{{ k.prefix || '' }}{{ k.value }}</span>
				<span class="kpi-unit">{{ k.unit }}</span>
			</div>
			<div class="kpi-delta-row">
				<i
					v-if="!isNeutral(k)"
					class="fas"
					:class="deltaDirection(k) === 'up' ? 'fa-arrow-up' : 'fa-arrow-down'"
					:style="{ color: deltaColor(k) }"
				></i>
				<span class="kpi-delta" :style="{ color: deltaColor(k) }">{{ formatDelta(k) }}</span>
				<span class="kpi-vs"><span v-text="$t('dashboard_gestao_kpi_vs_periodo_anterior')"></span></span>
			</div>
		</div>
	</div>
</template>

<script>
import DashboardGestaoController from '@/views/controllers/DashboardGestaoController';

export default {
	name: 'DashboardGestaoKpis',
	props: {
		kpis: { type: Array, default: () => [] },
	},
	methods: {
		isNeutral(k) {
			return DashboardGestaoController.isKpiDeltaNeutral(k.delta);
		},
		deltaDirection: DashboardGestaoController.getKpiDeltaDirection,
		deltaColor: DashboardGestaoController.getKpiDeltaColor,
		formatDelta: DashboardGestaoController.formatKpiDelta,
	},
};
</script>

<style scoped lang="less">
@card: #ffffff;
@line: #e7e9f0;
@ink: #1a2036;
@muted: #6b7280;
@blue: #2f9fe0;

.kpi-row {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	margin-bottom: 14px;
}

.kpi-card {
	background: @card;
	border-radius: 14px;
	border: 1px solid @line;
	box-shadow: 0 1px 2px rgba(20, 29, 56, 0.04);
	padding: 16px;
	flex: 1 1 220px;
	min-width: 220px;

	.kpi-head {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}

	.kpi-label {
		font-size: 12.5px;
		color: @muted;
		font-weight: 600;
		line-height: 1.3;
		max-width: 130px;
	}

	.kpi-icon {
		width: 30px;
		height: 30px;
		border-radius: 8px;
		background: #eef4fb;
		display: grid;
		place-items: center;
		color: @blue;
		flex-shrink: 0;
		cursor: help;

		i { font-size: 14px; }
	}

	.kpi-value-row {
		display: flex;
		align-items: baseline;
		gap: 4px;
		margin-top: 10px;
	}

	.kpi-value {
		font-size: 27px;
		font-weight: 800;
		color: @ink;
		letter-spacing: -1px;
	}

	.kpi-unit {
		font-size: 13px;
		color: @muted;
		font-weight: 600;
	}

	.kpi-delta-row {
		display: flex;
		align-items: center;
		gap: 3px;
		margin-top: 6px;
	}

	.kpi-delta {
		font-size: 12px;
		font-weight: 700;
	}

	.kpi-vs {
		font-size: 11.5px;
		color: @muted;
	}
}
</style>
